<div>
    <div class="column button is-offset-3 is-6 is-secondary" (click)="newguid()">Guid Me!</div>
    <div class="column is-offset-3 is-6 has-text-centered" *ngFor='let guid of guids; let idx = index'>
        <code id={{idx}} class="col is-fullwidth guid">{{guid | uppercase}}</code> <button class="button is-small"
            (click)="onCopy(idx)">Copy</button>

    </div>

</div>